var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tags)?_c('span',_vm._l((_vm.tags_list),function(tag,index){return _c('span',{key:index,staticClass:"badge badge-pill small mr-1",class:'badge-'+tag.color},[_vm._v(_vm._s(tag.tag))])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }